
export default {
	name: 'TermsPage',
	head ()
	{
		if (this.$route.path === '/') return {};

		const baseUrl = 'https://enifex.com';

		const breadcrumbData = {
			"@context": "https://schema.org",
			"@type": "BreadcrumbList",
			"itemListElement": [
			{
				"@type": "ListItem",
				"position": 1,
				"name": "Home",
				"item": baseUrl
			},
			{
				"@type": "ListItem",
				"position": 2,
				"name": "Terms of Use",
				"item": `${baseUrl}/terms-of-use`
			}
			]
		};
		return {
			title: 'Enifex - Terms of Use',
			link: [
				{
					rel: 'canonical',
					href: `https://www.enifex.com${this.$route.path}`
				}
			],
			script: [
				{
					hid: 'schema-terms-breadcrumb',
					type: 'application/ld+json',
					innerHTML: JSON.stringify(breadcrumbData)
				}
			]
		};
	},
}
